/**
 * @readonly
 * @enum {import("./interfaces").AnchorPoint}
 */
const anchorPoints = {
  LEFT: 'left',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  TOP: 'top',
  LEFT_TOP: 'left-top',
  LEFT_BOTTOM: 'left-bottom',
  RIGHT_TOP: 'right-top',
  RIGHT_BOTTOM: 'right-bottom',
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left'
}

export default anchorPoints
